import { ContentPayload, Payload } from '../types/ContentPayload';
import { formatContentPayloadToScriptPayload } from '../utils/formatContentPayloadToScriptPayload';
import { ScriptPayload } from '../types/sdk/Triggers';

/**
 * Configuration Service Class to cache content data
 * - the data can be fetched from the cache-manager docker service
 * @return class instance tracking up-to-date getConfig payload
 */
/**
 * ConfigurationService class handles the configuration settings and API calls for the player client.
 */
export class ConfigurationService {
  private static UNIT_ID: string = '';

  private static PORT: number = 1212;

  private static startupDate = new Date();

  private static contentPayload: ContentPayload = {
    contentChanged: ConfigurationService.startupDate.toDateString(),
    content: null,
    script: '',
  };

  private static scriptPayload: ScriptPayload = {
    triggers: [],
  };

  public static setUnitId(unitId: string) {
    ConfigurationService.UNIT_ID = unitId;
  }

  public static getUnitId() {
    return ConfigurationService.UNIT_ID;
  }

  public static setExpressPort(port: number): void {
    ConfigurationService.PORT = port;
  }

  public static getExpressPort(): number {
    return ConfigurationService.PORT;
  }

  /**
   * Fetches contentPayload API endpoint and updates local cache file
   * @return A promise with the config payload
   */
  private static async _getContent(
    unitId: string,
    unitContent: ContentPayload,
  ): Promise<ContentPayload> {
    ConfigurationService.contentPayload = unitContent;
    ConfigurationService.scriptPayload =
      formatContentPayloadToScriptPayload(unitContent);

    return unitContent;
  }

  /**
   * Public async function that can be used to access getConfig payload
   * if time of last fetch is more then whats specified in `ConfigurationService.invalidationTime` then payload is refetched
   * @param revalidate - if true, the payload is refetched
   * @return a promise with the config payload (either from cache or in edge cases from trisync)
   */
  public static async accessConfig(
    unitContent?: ContentPayload,
  ): Promise<Payload> {
    if (unitContent) {
      ConfigurationService._getContent(
        ConfigurationService.UNIT_ID,
        unitContent,
      );
    }

    return {
      contentPayload: ConfigurationService.contentPayload,
      scriptPayload: ConfigurationService.scriptPayload,
    };
  }
}
